import { render, staticRenderFns } from "./MtCasesModal.vue?vue&type=template&id=a8bfd050&"
import script from "./MtCasesModal.vue?vue&type=script&lang=js&"
export * from "./MtCasesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports